module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('b-form', {
    attrs: {
      "inline": ""
    },
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Baseline 1:",
      "description": "Select the first baseline you'd like to compare",
      "label-for": "baseline-1"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "baseline-1",
      "options": _vm.baselinesArray,
      "required": ""
    },
    model: {
      value: (_vm.selectedBaselinesLite.baselineOne),
      callback: function($$v) {
        _vm.selectedBaselinesLite.baselineOne = $$v
      },
      expression: "selectedBaselinesLite.baselineOne"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "Baseline 2:",
      "description": "Select the second baseline you'd like to compare",
      "label-for": "baseline-2"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "baseline-2",
      "options": _vm.baselinesArray,
      "required": ""
    },
    model: {
      value: (_vm.selectedBaselinesLite.baselineTwo),
      callback: function($$v) {
        _vm.selectedBaselinesLite.baselineTwo = $$v
      },
      expression: "selectedBaselinesLite.baselineTwo"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": !_vm.selectedBaselinesLite.baselineOne || !_vm.selectedBaselinesLite.baselineTwo || _vm.loading
    }
  }, [(_vm.loading) ? _c('span', [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Comparing")], 1) : _c('span', [_vm._v("Compare")])])], 1)], 1), _vm._v(" "), (_vm.hasResults && _vm.requirementTypeLookupReady) ? _c('table', {
    staticClass: "rm-table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((Array.from(_vm.diffLookup)), function(requirement) {
    return _c('tbody', [_c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.goToReq(requirement[0])
        }
      }
    }, [_vm._v(_vm._s(_vm.getDisplayID(requirement[0])))])]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    })]), _vm._v(" "), (requirement[1].has('name')) ? _c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }, [_vm._v("\n        Name\n      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }, [(requirement[1].get('name').baselineOne) ? _c('span', [_vm._v(_vm._s(requirement[1].get('name').baselineOne))]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    }, [(requirement[1].get('name').baselineTwo) ? _c('span', [_vm._v(_vm._s(requirement[1].get('name').baselineTwo))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (requirement[1].has('requirement_type_id')) ? _c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }, [_vm._v("\n        Type\n      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }, [(requirement[1].get('requirement_type_id').baselineOne) ? _c('span', [_vm._v("\n          " + _vm._s(_vm.requirementTypeLookup[requirement[1].get('requirement_type_id').baselineOne].name) + " requirement\n        ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    }, [(requirement[1].get('requirement_type_id').baselineTwo) ? _c('span', [_vm._v("\n          " + _vm._s(_vm.requirementTypeLookup[requirement[1].get('requirement_type_id').baselineTwo].name) + " requirement\n        ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (requirement[1].has('assigned_to')) ? _c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }, [_vm._v("\n        Assignee\n      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }, [(requirement[1].get('assigned_to').baselineOne && _vm.userLookup[requirement[1].get('assigned_to').baselineOne.account_id]) ? _c('span', [_vm._v("\n          " + _vm._s(_vm.userLookup[requirement[1].get('assigned_to').baselineOne.account_id].displayName) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    }, [(requirement[1].get('assigned_to').baselineTwo && _vm.userLookup[requirement[1].get('assigned_to').baselineTwo.account_id]) ? _c('span', [_vm._v("\n          " + _vm._s(_vm.userLookup[requirement[1].get('assigned_to').baselineTwo.account_id].displayName) + "\n        ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (requirement[1].has('status')) ? _c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }, [_vm._v("\n        Status\n      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }, [(requirement[1].get('status').baselineOne) ? _c('span', [_vm._v("\n          " + _vm._s(_vm.statusMap.get(requirement[1].get('status').baselineOne.atlassian_status_id.toString()).name) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    }, [(requirement[1].get('status').baselineTwo) ? _c('span', [_vm._v("\n          " + _vm._s(_vm.statusMap.get(requirement[1].get('status').baselineTwo.atlassian_status_id.toString()).name) + "\n        ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (requirement[1].has('components')) ? _c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }, [_vm._v("\n        Components\n      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }, [(requirement[1].get('components').baselineOne) ? _c('div', _vm._l((requirement[1].get('components').baselineOne), function(component) {
      return _c('span', [_vm._v("\n          " + _vm._s(_vm.componentMap.get(component.atlassian_component_id.toString()).name) + "\n          ")])
    })) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    }, [(requirement[1].get('components').baselineTwo) ? _c('div', _vm._l((requirement[1].get('components').baselineTwo), function(component) {
      return _c('span', [_vm._v("\n          " + _vm._s(_vm.componentMap.get(component.atlassian_component_id.toString()).name) + "\n          ")])
    })) : _vm._e()])]) : _vm._e(), _vm._v(" "), (requirement[1].has('description')) ? _c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }, [_vm._v("\n        Description\n      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }, [(requirement[1].get('description').baselineOne) ? _c('b-form-textarea', {
      attrs: {
        "plaintext": "",
        "no-resize": "",
        "max-rows": 6,
        "value": requirement[1].get('description').baselineOne
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    }, [(requirement[1].get('description').baselineTwo) ? _c('b-form-textarea', {
      attrs: {
        "plaintext": "",
        "no-resize": "",
        "max-rows": 6,
        "value": requirement[1].get('description').baselineTwo
      }
    }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (requirement[1].has('linked_requirements')) ? _c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }, [_vm._v("\n        Linked Requirements\n      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }, [(requirement[1].get('linked_requirements').baselineOne) ? _c('span', _vm._l((requirement[1].get('linked_requirements').baselineOne), function(reqOne) {
      return _c('span', [_c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            _vm.goToReq(reqOne.requirement_id)
          }
        }
      }, [_vm._v(_vm._s(reqOne.requirement_type.prefix) + _vm._s(reqOne.display_id ? reqOne.display_id : reqOne.requirement_id))]), _vm._v(" \n          ")])
    })) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    }, [(requirement[1].get('linked_requirements').baselineTwo) ? _c('span', _vm._l((requirement[1].get('linked_requirements').baselineTwo), function(reqTwo) {
      return _c('span', [_c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            _vm.goToReq(reqTwo.requirement_id)
          }
        }
      }, [_vm._v(_vm._s(reqTwo.requirement_type.prefix) + _vm._s(reqTwo.display_id ? reqTwo.display_id : reqTwo.requirement_id))]), _vm._v(" \n          ")])
    })) : _vm._e()])]) : _vm._e(), _vm._v(" "), (requirement[1].has('issues') && Object.keys(_vm.issueLookup).length > 0) ? _c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }, [_vm._v("\n        Linked Issues\n      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }, [(requirement[1].get('issues').baselineOne) ? _c('div', _vm._l((requirement[1].get('issues').baselineOne), function(issue) {
      return _c('span', [_c('a', {
        attrs: {
          "target": "_blank",
          "href": ((_vm.$auth.user().atlassian_base_url) + "/browse/" + (_vm.issueLookup[issue.atlassian_issue_id.toString()].key))
        }
      }, [_vm._v(_vm._s(_vm.issueLookup[issue.atlassian_issue_id.toString()].key))]), _vm._v(" \n        ")])
    })) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    }, [(requirement[1].get('issues').baselineTwo) ? _c('div', _vm._l((requirement[1].get('issues').baselineTwo), function(issue) {
      return _c('span', [_c('a', {
        attrs: {
          "target": "_blank",
          "href": ((_vm.$auth.user().atlassian_base_url) + "/browse/" + (_vm.issueLookup[issue.atlassian_issue_id.toString()].key))
        }
      }, [_vm._v(_vm._s(_vm.issueLookup[issue.atlassian_issue_id.toString()].key))]), _vm._v(" \n        ")])
    })) : _vm._e()])]) : _vm._e(), _vm._v(" "), (requirement[1].has('contents')) ? _c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }, [_vm._v("\n        Linked Confluence Content\n      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }, [(requirement[1].get('contents').baselineOne) ? _c('div', _vm._l((requirement[1].get('contents').baselineOne), function(content) {
      return _c('span', [_vm._v("\n          " + _vm._s(content.atlassian_content_id) + "\n        ")])
    })) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    }, [(requirement[1].get('contents').baselineTwo) ? _c('div', _vm._l((requirement[1].get('contents').baselineTwo), function(content) {
      return _c('span', [_vm._v("\n          " + _vm._s(content.atlassian_content_id) + "\n        ")])
    })) : _vm._e()])]) : _vm._e(), _vm._v(" "), (requirement[1].has('attachments')) ? _c('tr', [_c('td', {
      attrs: {
        "headers": "id"
      }
    }), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "field"
      }
    }, [_vm._v("\n        Attachments\n      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-one"
      }
    }, [(requirement[1].get('attachments').baselineOne) ? _c('div', _vm._l((requirement[1].get('attachments').baselineOne), function(attachment) {
      return _c('span', [_vm._v("\n          " + _vm._s(attachment.original_file_name) + "\n        ")])
    })) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "headers": "baseline-two"
      }
    }, [(requirement[1].get('attachments').baselineTwo) ? _c('div', _vm._l((requirement[1].get('attachments').baselineTwo), function(attachment) {
      return _c('span', [_vm._v("\n          " + _vm._s(attachment.original_file_name) + "\n        ")])
    })) : _vm._e()])]) : _vm._e()])
  })], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "id": "id"
    }
  }, [_vm._v("Requirement ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "id": "name"
    }
  }, [_vm._v("Field")]), _vm._v(" "), _c('th', {
    attrs: {
      "id": "baseline-one"
    }
  }, [_vm._v("Baseline 1")]), _vm._v(" "), _c('th', {
    attrs: {
      "id": "baseline-two"
    }
  }, [_vm._v("Baseline 2")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55dd59e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaselineComparison.vue
// module id = 1014
// module chunks = 1